import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/services/base.services';

@Injectable()
export class EmploymentService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService,
    private store: Store<any>) {
    super(toastr);
  }

  getBalances(accountId: number): Observable<any> {
    return this.http.get(environment.apiUrl + `/member-portal/Employment/account/${accountId}/balances`, { headers: this.headers() });
  }

  getCurrentEmployment(accountId: number): Observable<any> {
    return this.http.get(environment.apiUrl + `/member-portal/Employment/account/${accountId}/current`, { headers: this.headers() });
  }

}
